import { render, staticRenderFns } from "./PriceCategories.vue?vue&type=template&id=4a86ca88"
import script from "./PriceCategories.vue?vue&type=script&lang=js"
export * from "./PriceCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports